import { Flat, FlatState, FloorPlan } from "./types";

export const getFlatSize = (floorPlan: FloorPlan) =>
  floorPlan
    ?.reduce((acc, room) => {
      if (room?.primary) {
        return acc + (room.size ?? 0);
      }

      return acc;
    }, 0)
    .toFixed(2);

export const getCellarSize = (floorPlan: FloorPlan) => {
  const cellar = floorPlan?.find((room) => room?.type === "cellar");

  return cellar?.size?.toFixed(2) ?? false;
};

export const getTerraceSize = (floorPlan: FloorPlan) =>
  floorPlan
    ?.reduce((acc, room) => {
      if (room?.type === "terrace" || room?.type === "balcony") {
        return acc + (room.size ?? 0);
      }

      return acc;
    }, 0)
    .toFixed(2);

export const getFlatTower = (flat: Flat) => {
  if (flat.flat_id) {
    const [tower] = flat.flat_id.split(".");

    return tower;
  }

  return "N/A";
};

export const getFlatLevel = (flat: Flat) => {
  if (flat.flat_id) {
    const [_, level] = flat.flat_id.split(".");

    return level;
  }

  return "N/A";
};

const COUNTABLE_ROOMS = ["office", "room", "living_room_kitchen"];

export const getRoomsCount = (flat: Flat) =>
  flat.floor_plan?.reduce((acc, room) => {
    const type = room?.type ?? "";

    return COUNTABLE_ROOMS.includes(type) ? acc + 1 : acc;
  }, 0) ?? 0;

export const dashesToDots = (text: string | null) => text?.replace(/\./g, "-");
export const dotsToDashes = (text: string | null) => text?.replace(/-/g, ".");

export const getCenterOfElement = (element: Element, yOffset: number) => {
  const { x, y, width, height } = element.getBoundingClientRect();
  return { x: x + width / 2, y: y + height / 2 + yOffset };
};

export const getBaseAndNumberFromElementId = (id: string) => {
  const lastUnderscoreIndex = id.lastIndexOf("_");

  if (lastUnderscoreIndex !== -1) {
    const possibleNumber = id.substring(lastUnderscoreIndex + 1);

    if (!isNaN(parseInt(possibleNumber, 10)) && possibleNumber.trim() !== "") {
      const base = id.substring(0, lastUnderscoreIndex);
      const number = parseInt(possibleNumber, 10);

      return { base, number };
    }
  }

  return { base: id, number: null };
};

export const getSVGtransform = (flip: string) => {
  const splitFlip = (flip ?? "").split("");

  const svgTransformX = splitFlip.some((char) => char === "H") ? "-1" : "1";
  const svgTransformY = splitFlip.some((char) => char === "V") ? "-1" : "1";

  return `scale(${svgTransformX}, ${svgTransformY})`;
};

export const getThousandsWithSpace = (value: number | null) => {
  return value ? value.toLocaleString("en-US").replace(/,/g, " ") : value;
};

export const scrollToElement = (id: string) => {
  const element = document.getElementById(id);

  if (element) {
    element.scrollIntoView({ behavior: "smooth", block: "start" });
  }
};

export const getFlatStateCssSelector = (flats: Flat[], state: FlatState) =>
  flats?.reduce((acc, flat) => {
    const flatNumber = (flat.flat_id ?? "").split(".")[2];

    if (flat.state === state) {
      return `${acc} #flat_${flatNumber},`;
    }

    return acc;
  }, "");
